import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants, links } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import FacebookRegisterForm from 'components/forms/FacebookRegisterForm/FacebookRegisterForm'
import Modal from 'components/modal/Modal/Modal'

import messages from './messages'
import s from './FacebookRegisterModal.scss'


class FacebookRegisterModal extends Component {

  static propTypes = {
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.FacebookRegister,
  }

  handleClose = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  submit = ({ email, password }) => {
    actions.models.user.facebookAuth({
      email,
      password,
      tokenName: constants.requestTokens.facebookSigninManualEmail,
    })
      .then(
        () => {
          this.handleClose()
          actions.models.router.push(links.subscribe)
        },
        (rejectionMessage) => {
          if (rejectionMessage !== 'break') {
            actions.models.modals.open(constants.modals.Dialog, {
              contentMessage: messages.errorMsg,
              buttonTitle: messages.btnOk,
            })
          }
        }
      )
  }

  render() {
    const { name, data: { email } } = this.props

    return (
      <Modal
        className={s.registerModal}
        name={name}
        title={messages.title}
        onClose={this.handleClose}
        titleUppercase
      >
        <FormattedHTMLMessage className={s.text} {...messages.text} />
        <div className={s.form}>
          <FacebookRegisterForm onSubmit={this.submit} email={email} />
        </div>
      </Modal>
    )
  }
}


export default FacebookRegisterModal
